import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import SpotlightCard from './SpotlightCard';
import ShinyText from './ShinyText';

function Home_feablog() {
    return (
        <Container>
            <Row>
                <h1 className="project-heading" style={{ textAlign: "left" }}>
                    Featured <strong className="purple">Blogs </strong>
                </h1>
                <Col md={6} className="project-card">
                    <SpotlightCard className="custom-spotlight-card" spotlightColor="rgba(0, 229, 255, 0.2)">
                        <h3>Black-Litterman Model</h3>
                        <p>Portfolio Management</p>
                    </SpotlightCard>
                </Col>

                <Col md={6} className="project-card">
                    <SpotlightCard className="custom-spotlight-card" spotlightColor="rgba(0, 229, 255, 0.2)">
                        <h3>....</h3>
                        <p>xxxxxxxxxxxxxxxxxxx</p>
                    </SpotlightCard>
                </Col>
                <p2 className="project-subheading">
                    <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
                        <ShinyText text="More..." disabled={false} speed={2} className='custom-class' style={{ textDecoration: "underline" }} />
                    </Link>
                </p2>
            </Row>
        </Container>
    );
}
export default Home_feablog;